import React from 'react'
import { Link } from 'react-router-dom'
import {Context as AuthContext} from '../Context/AuthContext'
import { useContext } from 'react'

const Header = () => {
    const token = localStorage.getItem('token')
    const {state} = useContext(AuthContext)

    console.log('[HEADER]', state)
    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <Link to='/' className="navbar-brand">VIGRANT VITALE</Link>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div   className="collapse navbar-collapse navbgcolor " id="navbarNav">
                <ul className="navbar-nav">
                <li className="nav-item active">
                    <Link to='/' className="nav-link" >COVID-19 <span className="sr-only">(current)</span></Link>
                </li>
                <li className="nav-item active">
                    <Link to='/malaria' className="nav-link" >MALARIA <span className="sr-only">(current)</span></Link>
                </li>
                <li className="nav-item">
                    <Link to='/lassa-fever' className="nav-link" >LASSA FEVER </Link>
                </li>


                </ul>

                <ul className="navbar-nav ml-auto">
                    <li className="nav-item">
                        {!token ? <Link to='/login' className="nav-link" >Login</Link>:
                        <div>
                            <Link to='/dashboard' className="nav-link" > Dashboard </Link>
                        </div>
                        }
                    </li>
                </ul>

            </div>
            </nav>


        </div>
    )
}

export default Header;